import React from "react";
import * as Yup from "yup";
import "./Organization.css";
import { useNavigate } from "react-router";
const postalCodePattern = /^[0-9]{5}(?:-[0-9]{4})?$/; // U.S. postal code pattern
const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const formikAddOrg = {
    initialValues: {
        orgName: "",
        phone: "",
        email: "",
        contactName : "",
        contactEmail : "",
        contactPhone : "",
        address : "",
        city: "",
        state: "",
        postalCode: "",
        country: "",
        orgLogo: null,
        type: "",
        secondaryContactName:"",
        secondaryContactPhone:"",
        secondarycontactEmail:""
    },
    validationSchema: Yup.object({
        orgName: Yup.string().required("Required Field"),
        type: Yup.string().required("Required Field"),
        email: Yup.string()
            .matches(emailPattern, "Enter a valid email address")
            .required("Required Field"),
        contactName: Yup.string().required("Required Field"),
        contactEmail: Yup.string()
            .matches(emailPattern, "Enter a valid email address")
            .required("Required Field"),
        address: Yup.string().required("Required Field"),
        city: Yup.string().required("Required Field"),
        state: Yup.string().required("Required Field"),
        postalCode: Yup.string()
            .matches(postalCodePattern, "Enter a valid postal code")
            .required("Required Field"),
        country: Yup.string().required("Required Field")
    })
};

export const formikAddClinic = {
    initialValues: {
        clinicName: "",
        phone: "",
        email: "",
        contactName : "",
        contactEmail : "",
        contactPhone : "",
        address : "",
        city: "",
        state: "",
        postalCode: "",
        country: "",
        type:"",
        secondaryContactName:"",
        secondaryContactPhone:"",
        secondarycontactEmail:"",
        orgId: ""
    },
    validationSchema: Yup.object({
        clinicName: Yup.string().required("Required Field"),
        type: Yup.string().required("Required Field"),
        contactName: Yup.string().required("Required Field"),
        contactEmail: Yup.string()
            .matches(emailPattern, "Enter a valid email address")
            .required("Required Field"),
        email: Yup.string()
            .matches(emailPattern, "Enter a valid email address")
            .required("Required Field"),
        address: Yup.string().required("Required Field"),
        city: Yup.string().required("Required Field"),
        state: Yup.string().required("Required Field"),
        postalCode: Yup.string()
            .matches(postalCodePattern, "Enter a valid postal code")
            .required("Required Field"),
        country: Yup.string().required("Required Field")
    })
};

export const formikAssignUser = {
    initialValues: {
        firstName: "",
        lastName: "",
        roles: [],
        email: "",
        primaryPhone: "",
        secondaryPhone: "",
        jobTitle: "",
        defaultLogInClinic: "",
        orgId: "",
        address: "",
        city: "",
        state: "",
        postalCode: "",
        country: "",
        userType: 'createNewUser',
        selectUser: "",
        existingUserId: "",
        roleType: "",
        employer: "",
        department: "",
        hospitalAccess: [],
        defaultLogInOrg : "",
        role:"",
        defaultRoleId : "",
        defaultRole :""
    },
    validationSchema: Yup.object({
        userType: Yup.string().required("User Type is required"),
        selectUser: Yup.string().when('userType', {
            is: 'createNewUser',
            then: (schema) => schema.nullable(),
            otherwise: (schema) => schema.required("Required Field")
        }),
        firstName: Yup.string().when('userType', {
            is: 'createNewUser',
            then: (schema) => schema.required("Required Field"),
            otherwise: (schema) => schema.nullable()
        }),
        lastName: Yup.string().when('userType', {
            is: 'createNewUser',
            then: (schema) => schema.required("Required Field"),
            otherwise: (schema) => schema.nullable()
        }),
        email: Yup.string().email("Invalid Email Format").when('userType', {
            is: 'createNewUser',
            then: (schema) => schema.required("Required Field"),
            otherwise: (schema) => schema.nullable()
        }),
        primaryPhone: Yup.string().when('userType', {
            is: 'createNewUser',
            then: (schema) => schema.required("Required Field"),
            otherwise: (schema) => schema.nullable()
        }),
        jobTitle: Yup.string().when('userType', {
            is: 'createNewUser',
            then: (schema) => schema.required("Required Field"),
            otherwise: (schema) => schema.nullable()
        }),
        address: Yup.string().when('userType', {
            is: 'createNewUser',
            then: (schema) => schema.required("Required Field"),
            otherwise: (schema) => schema.nullable()
        }),
        city: Yup.string().when('userType', {
            is: 'createNewUser',
            then: (schema) => schema.required("Required Field"),
            otherwise: (schema) => schema.nullable()
        }),
        state: Yup.string().when('userType', {
            is: 'createNewUser',
            then: (schema) => schema.required("Required Field"),
            otherwise: (schema) => schema.nullable()
        }),
        postalCode: Yup.string().when('userType', {
            is: 'createNewUser',
            then: (schema) => schema.required("Required Field"),
            otherwise: (schema) => schema.nullable()
        }),
        country: Yup.string().when('userType', {
            is: 'createNewUser',
            then: (schema) => schema.required("Required Field"),
            otherwise: (schema) => schema.nullable()
        }),
        employer: Yup.string().when('userType', {
            is: 'createNewUser',
            then: (schema) => schema.required("Required Field"),
            otherwise: (schema) => schema.nullable()
        }),
        department: Yup.string().when('userType', {
            is: 'createNewUser',
            then: (schema) => schema.required("Required Field"),
            otherwise: (schema) => schema.nullable()
        }),
        roles: Yup.mixed().when('userType', {
            is: 'createNewUser',
            then: (schema) => schema.required("Required Field"),
            otherwise: (schema) => schema.nullable()
        }),
        defaultRoleId: Yup.string().when('userType', {
            is: 'createNewUser',
            then: (schema) => schema.required("Required Field"),
            otherwise: (schema) => schema.nullable()
        }),
        defaultLogInClinic: Yup.string().when('userType', {
            is: 'createNewUser',
            then: (schema) => schema.required("Required Field"),
            otherwise: (schema) => schema.nullable()
        })
    })
};

export const sideTabs = ({ActiveStep, orgData, fromEdit, navigate})=>{
    return (
      <div className="tabs_button">
        <button className="cancel_btn_blk d-flex justify-content-between align-items-center" onClick={()=> fromEdit ? navigate("/super-admin/addOrganization",{ state: { ActiveStep: 1 , orgData: orgData, fromEdit : true} }) : null} style={ActiveStep === 1 ? {color: "white", backgroundColor:"#335FFC"} : null}>Organization{ActiveStep === 1 ? <i className="fa fa-check"></i> : <i className="fa fa-check"></i>}</button>
        <button className="next_btn_blk d-flex justify-content-between align-items-center"  onClick={()=> fromEdit ? navigate("/super-admin/clinicslist", { state: { ActiveStep: 2 , orgData: orgData, fromEdit : true, fromListing:true} }) : null} style={ActiveStep === 2 ? {color: "white", backgroundColor:"#335FFC"} : null}>Hospital Location {(ActiveStep === 2 || ActiveStep === 3) ? <i className="fa fa-check"></i> : <i className="fa fa-check" style={{backgroundColor : "grey"}}></i>}</button>
        <button className="next_btn_blk d-flex justify-content-between align-items-center"  onClick={()=> fromEdit ? navigate("/super-admin/userslist", { state: { ActiveStep: 3 , orgData: orgData, fromEdit : true} }) : null} style={ActiveStep === 3 ? {color: "white", backgroundColor:"#335FFC"} : null}>Users {ActiveStep === 3 ?  <i className="fa fa-check"></i> : <i className="fa fa-check" style={{backgroundColor : "grey"}}></i>}</button>
      </div>
    );
};

export const organizationTypeOption = [
    { value: "Birth Center", label: "Birth Center" },
    { value: "Care Organization", label: "Care Organization" },
    { value: "Private Clinic", label: "Private Clinic" },
    { value: "Community Health Center", label: "Community Health Center" },
    { value: "Dialysis Center", label: "Dialysis Center" },
    { value: "Health Center", label: "Health Center" },
    { value: "Home Care", label: "Home Care" },
    { value: "Hospital", label: "Hospital" },
    { value: "Hospital Network", label: "Hospital Network" },
    { value: "Medical Center", label: "Medical Center" },
    { value: "Medical Office", label: "Medical Office" },
    { value: "Mental Health Facility", label: "Mental Health Facility" },
    { value: "Palliative Care & Hospices Center", label: "Palliative Care & Hospices Center" },
    { value: "Private Health Insurance", label: "Private Health Insurance" },
    { value: "Rehabilitation Center", label: "Rehabilitation Center" },
    { value: "Skilled Nursing Home", label: "Skilled Nursing Home" }
];
